// extracted by mini-css-extract-plugin
module.exports = {"error":"Error-module--error--7V92J"};